import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'appPhoneNumber'
})

export class PhoneNumberPipe implements PipeTransform {
    transform(value: any, ...args: any[]): any {

        if(value) {
            let newVal = value.replace(/\D/g, '');
            return newVal.replace(/^(\d{0,3})(\d{0,3})(\d{0,4})/, '($1) $2-$3');
        }
        

        return value;
    }
}